import tooltipDirective from './Tooltip/';
import clipboardDirective from '@/directives/Clipboard';

// register all directives
const directives = (app) => {
  tooltipDirective(app);
  clipboardDirective(app);
};

export default directives;
